import React from 'react';
import { Button, Col, Row, Spin } from 'antd';
import { EyeOutlined, LoadingOutlined } from '@ant-design/icons';
import { IBaseFilter, IPlan } from '../../types/plans';
import { IMapController, IMapData } from '../../lib/map';
import Map from '../../components/containers/Map';
import { Filters } from '../../components/Plans/MapListFilters';
import { Plans } from '../../components/Plans/MapList';
import {
  loaderStyle,
  desktopContainerStyle,
  desktopMapContainerStyle,
  desktopSidebarStyle,
  desktopEstimateButtonStyle,
  basePlansListStyle,
} from './styles';

interface DesktopMapViewProps {
  refController: React.MutableRefObject<IMapController | null>;
  planView: IPlan | null;
  onChangeMapData: (data: IMapData) => void;
  setLoadMap: (loadMap: boolean) => void;
  loadMap: boolean;
  filters: IBaseFilter;
  setFilters: (filters: IBaseFilter) => void;
  loading: boolean;
  items: IPlan[];
  onPlace: (e: React.MouseEvent<HTMLDivElement>, plan: IPlan) => void;
  onNext: () => void | Promise<void>;
  primaryLabel?: string;
  currentPage: number;
  onPageChange: (page: number) => void;
  totalCount: number;
}

const DesktopMapView: React.FC<DesktopMapViewProps> = ({
  refController,
  planView,
  onChangeMapData,
  setLoadMap,
  loadMap,
  filters,
  setFilters,
  loading,
  items,
  onPlace,
  onNext,
  primaryLabel,
  currentPage,
  onPageChange,
  totalCount,
}) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  return (
    <Row style={desktopContainerStyle}>
      <Col span={24} md={14} style={desktopMapContainerStyle}>
        <Map
          refController={refController}
          plan={planView as IPlan}
          onChange={onChangeMapData}
          onLoad={setLoadMap}
        />
        {loadMap && (
          <div style={loaderStyle}>
            <Spin size="large" indicator={antIcon} />
          </div>
        )}
      </Col>
      <Col span={24} md={10} style={desktopSidebarStyle}>
        <Row justify="space-around" align="stretch">
          <Col span={22}>
            <Filters filters={filters} setFilters={setFilters} />
          </Col>
        </Row>
        <Row justify="space-around" align="stretch" style={basePlansListStyle}>
          <Col span={22}>
            {loading ? (
              <Row justify="center" style={{ height: '100%' }}>
                <Col>
                  <Spin size="large" indicator={antIcon} />
                </Col>
              </Row>
            ) : (
              <Plans
                items={items}
                onPlace={onPlace}
                currentPage={currentPage}
                onPageChange={onPageChange}
                totalCount={totalCount}
              />
            )}
          </Col>
        </Row>
        {planView?.id && (
          <Row
            justify="center"
            style={{
              height: '80px',
            }}>
            <Col span={22}>
              <Button
                disabled={loadMap}
                loading={loadMap}
                style={desktopEstimateButtonStyle}
                onClick={onNext}>
                <EyeOutlined />
                {primaryLabel || 'Estimate'}
              </Button>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default DesktopMapView;
